
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Product/Supplier/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `Product/Supplier/fetchList`,
})

methods.addNewRecord = function() {
  this.$refs.EntryDialog.new()
}

methods.editRecord = function(id) {
  this.$refs.EntryDialog.edit(id)
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Produk dan Inventory`)
  this.$store.commit(`set_breadcrumb`, [ `Data Kategori`, `List` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Daftar Supplier Toko

          <ButtonR text="Tambah Record" color="primary" @click="addNewRecord" />
          <ButtonR icon="repeat" color="default" @click="reload" />
        </template>
        <template #content>
          <ListTable @editrequest="editRecord" />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"></EntryDialog>
  </layout>
</template>